import { useSelector } from 'react-redux'

import {
  selectCockpitAttentionCockpitMode,
  selectCockpitSelectedAttentionStatusBit,
} from '../../../model/selectors'

/**
 * Whether the manager cockpit's drill-down stands inside a status.
 *
 * The grouping and the search act on the partners behind one status, so both controls belong to
 * that level: on the status list itself there is nothing yet to group or to search, and a control
 * that changes nothing visible reads as broken.
 */
export const useHasAttentionStatusDrill = (isManagerCockpitMode: boolean): boolean => {
  const cockpitMode = useSelector(selectCockpitAttentionCockpitMode)
  const selectedBit = useSelector(selectCockpitSelectedAttentionStatusBit)

  return isManagerCockpitMode && cockpitMode === 'multiple-partner' && selectedBit !== null
}
